var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.77H4.751c-.602 0-1.155-.281-1.477-.75a1.502 1.502 0 0 1-.106-1.554L4.5 12.991V10.1c0-3.803 3.136-6.918 7.14-7.092 2.075-.086 4.04.587 5.537 1.906 1.5 1.32 2.324 3.099 2.324 5.01v3.068l1.325 2.462a1.508 1.508 0 0 1-.098 1.567c-.323.47-.875.75-1.478.75ZM11.675 3.7h.005-.005Zm-2.63 14.992C9.286 20 10.518 21 12.002 21s2.716-1 2.955-2.308h-5.91Z",
    fill: "#2B2F38"
  })));
};

export default SvgAlarm;